export default class SlideActions {
  constructor() {
    this.generateActions(
      "addFragment",
      "updateFragment"
    );
  }
}



// WEBPACK FOOTER //
// ./~/@jimpick/spectacle/src/flux/slide-actions.jsx